import {deleteUserSubscription} from "../../../graphql/mutations"
import {CustomQuery} from "./types"

export const subscribe: CustomQuery = {
    queryKey: "createUserSubscription",
    type: "CREATE",
    query: /* GraphQL */ `
        mutation CreateUserSubscription(
            $input: CreateUserSubscriptionInput!
            $condition: ModelUserSubscriptionConditionInput
        ) {
            createUserSubscription(input: $input, condition: $condition) {
                id
                commentId
                userId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
            }
        }
    `
}

export const unsubscribe: CustomQuery = {
    queryKey: "deleteUserSubscription",
    type: "DELETE",
    query:  /* GraphQL */ `
        mutation DeleteUserSubscription(
            $input: DeleteUserSubscriptionInput!
            $condition: ModelUserSubscriptionConditionInput
        ) {
            deleteUserSubscription(input: $input, condition: $condition) {
                id
                commentId
                discussionId
                userId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
            }
        }
    `
}
